import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/da4986e1-cb03-4e30-af82-5c3f0aea4565";
export const REGISTER_URL = "https://a.ntrk2.com/23296574-3cfd-4028-9dc8-ad57de716f51";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gogobd.kzw2a.com/download?openExternalBrowser=1&id=tdnr2c02lqscsca";

export * from "./codes";
export * from "./context";
